import { Backdrop, Box, Button, ButtonGroup, Card, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import vcplogo from '../../images/VCPLogo.png'
import { HuePicker } from 'react-color'
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';

import PhotoOne from '../../images/nature-6655730_640.jpg'
import PhotoTwo from '../../images/tulips-3339416_640.jpg'
import PhotoThree from '../../images/plum-blossoms-7860381_640.jpg'

const DemoForWp = () => {
    const [color, setColor] = useState('#28A745')
    const [backdropOpen, setBackdropOpen] = useState(true)
    const [bg, setBg] = useState(0)
    const [demoText, setDemoText] = useState('')

    const bgs = [PhotoOne, PhotoTwo, PhotoThree]
        
    useEffect(() => {
        setTimeout(() => {
            const badge = document.getElementsByClassName('grecaptcha-badge')[0];
            if (badge) {
                badge.style.visibility = 'hidden'
            }
        }, 500)
    }, [])

  return (
    <>
        <Backdrop open={backdropOpen} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1, display: "flex", flexDirection: "column", alignItems: "center", gap: "20px"})}>
            <Typography variant='h2'>How it works?</Typography>
            <Button variant='contained' onClick={() => setBackdropOpen(false)}>Show demo</Button>
        </Backdrop>
        <Typography variant='h4' sx={{
            mt: 3,
            mx: 1
        }} textAlign="center" >CMS - Manage content displayed on the screen</Typography>
        <Box sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "20px",
            mt: 3,
            mx: 1
        }}>
            <Card variant='outlined' sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                maxWidth: "400px",
                gap: "20px",
            }}>
                <Box sx={{
                    p: 1,
                    display: "flex",
                    gap: "15px",
                    alignItems: "center",
                    backgroundColor: "#1C2536",
                    width: "100%"
                }}>
                    <img src={vcplogo} alt="Logo" style={{
                        width: '40px'
                    }} />
                    <Typography variant='h6'>App</Typography>
                </Box> 
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "20px",
                    p: 1,
                    pb: 2
                }}>
                    <Typography variant='h6' textAlign="center">Edit Your screen</Typography>
                    <div style={{position: "relative" }}>
                        <HuePicker onChangeComplete={(c) => setColor(c.hex)} color={color} />
                    </div>
                    <ButtonGroup size="small">
                        <Button onClick={() => setBg(0)} variant={bg == 0 ? 'contained' : 'outlined'}>Photo 1</Button>
                        <Button onClick={() => setBg(1)} variant={bg == 1 ? 'contained' : 'outlined'}>Photo 2</Button>
                        <Button onClick={() => setBg(2)} variant={bg == 2 ? 'contained' : 'outlined'}>Photo 3</Button>
                    </ButtonGroup>
                    <TextField value={demoText} onInput={(e) => setDemoText(e.target.value)} variant="outlined" size="small" label="text" inputProps={{ maxLength: 20 }} />
                </Box>
            </Card>
            <Box sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column"
            }}>
                <DoubleArrowIcon fontSize='large' />
            </Box>
            <Card variant='outlined' sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                maxWidth: "400px",
                minHeight: "280px",
                gap: "20px",
                backgroundImage: `url(${bgs[bg]})`,
                backgroundSize: "cover"
            }}>
                <Box sx={{
                    p: 1,
                    display: "flex",
                    gap: "15px",
                    alignItems: "center",
                    backgroundColor: "#1C2536",
                    width: "100%"
                }}>
                    <Typography variant='h6'>Screen</Typography>
                </Box> 
                <Typography variant='h3' color={color}>{demoText}</Typography>
                <Box sx={{
                    p: 1,
                    display: "flex",
                    gap: "15px",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    backgroundColor: "#1C2536",
                    width: "100%"
                }}>
                    <PowerSettingsNewIcon color='error' fontSize='20px' />
                </Box> 
            </Card>
        </Box>
    </>
  )
}

export default DemoForWp
